import { Sparkles } from 'lucide-react';

interface Props {
  suggestions: string[];
  onPick: (text: string) => void;
  disabled?: boolean;
}

// SuggestionChips renders the proactive follow-up prompts emitted after
// a turn finishes. Click → parent stuffs the chip text into the input
// box (not auto-sent) so the user can tweak before submitting.
export function SuggestionChips({ suggestions, onPick, disabled }: Props) {
  if (!suggestions || suggestions.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5 pl-1">
      <Sparkles className="h-3 w-3 text-primary/70" aria-hidden />
      {suggestions.map((s, i) => (
        <button
          key={`${i}-${s}`}
          type="button"
          onClick={() => onPick(s)}
          disabled={disabled}
          className={[
            'rounded-full border border-primary/30 bg-primary/5 px-2.5 py-1 text-[11px]',
            'text-primary transition hover:bg-primary/10 hover:border-primary/50',
            'dark:border-primary/40 dark:bg-primary/10 dark:text-primary',
            'disabled:opacity-40 disabled:cursor-not-allowed',
          ].join(' ')}
          title={s}
        >
          {s}
        </button>
      ))}
    </div>
  );
}
